import React from 'react'

import {
  useImagesSize,
  useShouldHideColors,
  useShouldHideImages,
  useShouldHideSign
} from './options/_form/PdfOptionsFormHandler'

const _Image = ({
  style = {},
  maxWidth,
  maxHeight,
  height,
  width,
  src,
  ignoreFixedSize,
  ignoreHide,
  type,
  ...props
}) => {
  const hideColors = useShouldHideColors()
  const hideImages = useShouldHideImages()
  const hideSign = useShouldHideSign()
  const { imagesHeight } = useImagesSize()

  const isSign = type === 'sign'

  if (hideImages && !isSign && !ignoreHide) return false
  if (hideSign && isSign && !ignoreHide) return false

  style = {
    height: height || 'auto',
    maxWidth: maxWidth || '100%',
    display: 'block',
    filter: hideColors && 'grayscale(100%)',
    maxHeight,
    width,
    ...style
  }

  if (!!imagesHeight && !ignoreFixedSize)
    return (
      <img
        src={src}
        style={{
          ...style,
          height: imagesHeight,
          width: style.width || 'auto',
          objectFit: 'cover',
          objectPosition: 'center'
        }}
        {...props}
      />
    )

  return <img style={style} src={src} {...props} />
}

export default _Image
